import React, { useEffect, useState } from "react";
import { Button, Form, Input, FormGroup, Label, Table } from "reactstrap";
import ResponseLoader from "../../ShortCutComponents/ResponseLoader";
import swal from "sweetalert2";
import axios from "axios";
import { GetIp } from "../../ShortCutComponents/Get_ip";
import { baseurl } from "../../../../baseurl";

export default function PayDays(props) {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");

  const [loadingResponse, setLoadingResponse] = useState(false);
  const [data, setData] = useState({
    desc1: "",
    showModalAddNew: true,
  });
  const [PayDays, setPayDays] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({ desc1: "" });

  const cleanInput = () => {
    setData({ desc1: "" });
  };

  const getData = () => {
    axios
      .post(
        `${baseurl}/payRoll/getPayDays`,
        { companyId, username },
        { headers: { authorization: token } }
      )
      .then((res) => {
        setPayDays(res.data.data);
        console.log(res.data.data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getData();
  }, []);

  const inputEvent = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmitAddItem = async (event) => {
    event.preventDefault();
    setLoadingResponse(true);
    let { userIp, userCountry } = await GetIp();

    axios
      .post(
        `${baseurl}/payRoll/AddPayDays`,
        {
          companyId,
          desc1: data.desc1,
          username,
          userIp,
          userCountry,
        },
        { headers: { authorization: token } }
      )
      .then((response) => {
        setLoadingResponse(false);
        if (response.data.duplicate) {
          swal.fire({
            title: "Duplicate Code is not Allowed",
            text: "Duplicate Entry",
            icon: "error",
          });
        } else {
          swal
            .fire({
              title: "Saved Successfully!",
              text: "PayDays Added",
              icon: "success",
            })
            .then(() => {
              console.log("response.data.data", response.data.data);
              setPayDays([
                ...PayDays,
                { pay_days_id: response.data.data, desc1: data.desc1 },
              ]);
              setData({ desc1: "" });
            });
        }
      })
      .catch(() => {
        setLoadingResponse(false);
        swal.fire({
          title: "Error",
          text: "Something went wrong. Try again.",
          icon: "error",
        });
      });
  };

  const handleEdit = (PayDays) => {
    console.log("PayDays", PayDays);
    setEditingId(PayDays.pay_days_id);
    setEditData({ desc1: PayDays.desc1 });
  };

  const handleUpdate = () => {
    axios
      .post(
        `${baseurl}/payRoll/updatePayDays`,
        {
          companyId,
          username,
          pay_days_id: editingId,
          desc1: editData.desc1,
        },
        { headers: { authorization: token } }
      )
      .then(() => {
        setPayDays(
          PayDays.map((item) =>
            item.pay_days_id === editingId ? { ...item, ...editData } : item
          )
        );
        console.log("editingId", editingId);
        setEditingId(null);
        getData();

        swal.fire({
          title: "Updated!",
          text: "PayDays Updated Successfully",
          icon: "success",
        });
      })
      .catch(() => {
        swal.fire({
          title: "Error",
          text: "Something went wrong, try again.",
          icon: "error",
        });
      });
  };
  const handleDelete = (pay_days_id) => {
    swal
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        buttons: ["Cancel", "Delete"],
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          axios
            .post(
              `${baseurl}/payRoll/deletePayDays`,
              { companyId, username, pay_days_id },
              { headers: { authorization: token } }
            )
            .then(() => {
              setPayDays(
                PayDays.filter((item) => item.pay_days_id !== pay_days_id)
              );
              swal.fire("Deleted!", "PayDays has been deleted.", "success");
            })
            .catch(() => {
              swal.fire("Error!", "Something went wrong. Try again.", "error");
            });
        }
      });
  };

  return (
    <>
      {loadingResponse ? (
        <ResponseLoader />
      ) : (
        <div className="container-fluid bg-white pb-2">
          <div className="row d-flex justify-content-between">
            <div className="col-md-8 h3 p-3">Pay Days</div>
            <div className="mt-3 mr-4"></div>
          </div>
          <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <Label style={{ fontWeight: "bold" }}>
                  Pay Days Description:
                </Label>
                <Input
                  value={data.desc1}
                  onChange={inputEvent}
                  required
                  name="desc1"
                />
              </div>
            </div>
            <FormGroup>
              <Button type="submit" className="mr-2 invoiceSubmitButton">
                Save
              </Button>
              <Button onClick={cleanInput} size="sm">
                Cancel
              </Button>
            </FormGroup>
          </Form>

          <div translate="no" className="mb-2">
            <Table bordered striped className="mt-4 ">
              <thead>
                <tr>
                  <th>Pay Days Description</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {PayDays.length > 0 ? (
                  PayDays.map((PayDays) => (
                    <tr key={PayDays.pay_days_id}>
                      <td>
                        {editingId === PayDays.pay_days_id ? (
                          <Input
                            value={editData.desc1}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                desc1: e.target.value,
                              })
                            }
                          />
                        ) : (
                          PayDays.desc1
                        )}
                      </td>
                      <td width="20%">
                        {editingId === PayDays.pay_days_id ? (
                          <>
                            <Button
                              type="button"
                              className="m-1"
                              size="sm"
                              color="secondary"
                              onClick={() => {
                                setEditingId(null); // Cancel editing
                                setEditData({
                                  desc1: "",
                                });
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              color="success"
                              size="sm"
                              onClick={handleUpdate}
                            >
                              Save
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              type="button"
                              className="m-1"
                              size="sm"
                              color="danger"
                              onClick={() => handleDelete(PayDays.pay_days_id)}
                            >
                              Delete
                            </Button>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => handleEdit(PayDays)}
                            >
                              Edit
                            </Button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </>
  );
}
